/**
 * Mainbeauty — droplist tuỳ biến cho <select> form lead; <select> gốc vẫn ở DOM cho FormData/validate.
 */

const TYPEAHEAD_RESET = 700; // ms — hết khoảng này thì gõ chữ là tìm từ đầu

let seq = 0;

// Mọi droplist đã dựng — dùng để đóng cái đang mở khi mở cái khác / click ra ngoài.
const registry = [];

function closeAll(except) {
  registry.forEach((wrap) => {
    if (wrap !== except) wrap.close();
  });
}

function build(select) {
  if (select.dataset.piSelectReady) return;
  select.dataset.piSelectReady = "1";

  const baseId = select.id || `pi-select-${++seq}`;
  const wrap = document.createElement("div");
  wrap.className = "pi-select";
  select.parentNode.insertBefore(wrap, select);

  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.id = `${baseId}-toggle`;
  toggle.className = "inp pi-select__toggle";
  toggle.setAttribute("aria-haspopup", "listbox");
  toggle.setAttribute("aria-expanded", "false");

  const value = document.createElement("span");
  value.className = "pi-select__value";
  const arrow = document.createElement("span");
  arrow.className = "pi-select__arrow pi-chev pi-chev--sm";
  arrow.setAttribute("aria-hidden", "true");
  toggle.append(value, arrow);

  const menu = document.createElement("ul");
  menu.id = `${baseId}-menu`;
  menu.className = "pi-select__menu";
  menu.setAttribute("role", "listbox");
  menu.hidden = true;
  toggle.setAttribute("aria-controls", menu.id);

  const items = Array.prototype.map.call(select.options, (opt, i) => {
    const li = document.createElement("li");
    li.className = "pi-select__option";
    li.id = `${baseId}-opt-${i}`;
    li.setAttribute("role", "option");
    li.tabIndex = -1;
    li.textContent = opt.textContent;
    menu.appendChild(li);
    return li;
  });

  wrap.append(toggle, menu, select);

  // Nhãn <label for="select"> phải trỏ sang nút, vì select đã ẩn.
  const label = document.querySelector(`label[for="${CSS.escape(baseId)}"]`);
  if (label) {
    label.htmlFor = toggle.id;
    if (!label.id) label.id = `${baseId}-label`;
    menu.setAttribute("aria-labelledby", label.id);
  }

  const sync = () => {
    const index = select.selectedIndex < 0 ? 0 : select.selectedIndex;
    const opt = select.options[index];
    value.textContent = opt ? opt.textContent : "";
    value.classList.toggle("is-placeholder", !opt || opt.value === ""); // option rỗng đóng vai placeholder
    items.forEach((li, i) => li.setAttribute("aria-selected", i === index ? "true" : "false"));
  };

  const isOpen = () => !menu.hidden;

  const close = ({ focusToggle = false } = {}) => {
    if (!isOpen()) return;
    menu.hidden = true;
    wrap.classList.remove("is-open", "pi-select--up");
    toggle.setAttribute("aria-expanded", "false");
    if (focusToggle) toggle.focus();
  };

  const open = () => {
    if (isOpen() || select.disabled) return;
    closeAll();
    menu.hidden = false;
    wrap.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");

    // Không đủ chỗ bên dưới (form nằm cuối màn hình) thì bung lên trên.
    const box = toggle.getBoundingClientRect();
    const menuH = menu.offsetHeight;
    if (box.bottom + menuH + 12 > window.innerHeight && box.top > menuH + 12) {
      wrap.classList.add("pi-select--up");
    }

    const current = items[select.selectedIndex] || items[0];
    if (current) {
      current.focus();
      current.scrollIntoView({ block: "nearest" });
    }
  };

  // Mọi thay đổi đi qua <select> gốc rồi phát `change`, để pi-leads.js tự đồng bộ.
  const choose = (index) => {
    if (index < 0 || index >= items.length) return;
    if (select.selectedIndex !== index) {
      select.selectedIndex = index;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    close({ focusToggle: true });
  };

  const move = (from, step) => {
    const next = Math.min(items.length - 1, Math.max(0, from + step));
    items[next].focus();
  };

  const focusedIndex = () => items.indexOf(document.activeElement);

  toggle.addEventListener("click", () => (isOpen() ? close() : open()));

  toggle.addEventListener("keydown", (e) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      open();
    }
  });

  menu.addEventListener("click", (e) => {
    const li = e.target.closest(".pi-select__option");
    if (li) choose(items.indexOf(li));
  });

  menu.addEventListener("keydown", (e) => {
    const at = focusedIndex();
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        move(at, 1);
        break;
      case "ArrowUp":
        e.preventDefault();
        move(at, -1);
        break;
      case "Home":
        e.preventDefault();
        items[0].focus();
        break;
      case "End":
        e.preventDefault();
        items[items.length - 1].focus();
        break;
      case "Enter":
      case " ":
        e.preventDefault();
        choose(at);
        break;
      case "Escape":
      case "Tab":
        close({ focusToggle: true });
        break;
      default:
        typeahead(e.key, at);
    }
  });

  // Gõ chữ để nhảy tới khóa học bắt đầu bằng chữ đó.
  let buffer = "";
  let bufferAt = 0;
  function typeahead(key, at) {
    if (key.length !== 1) return;
    const now = Date.now();
    buffer = now - bufferAt > TYPEAHEAD_RESET ? key : buffer + key;
    bufferAt = now;
    const needle = buffer.toLowerCase();
    const start = at < 0 ? 0 : at;
    for (let i = 1; i <= items.length; i++) {
      const li = items[(start + i) % items.length];
      if (li.textContent.trim().toLowerCase().startsWith(needle)) {
        li.focus();
        li.scrollIntoView({ block: "nearest" });
        return;
      }
    }
  }

  // Giá trị đổi từ nơi khác: CTA khóa học, prefill ?khoa=, form.reset().
  select.addEventListener("change", sync);
  const form = select.form;
  if (form) form.addEventListener("reset", () => setTimeout(sync, 0));

  // validate JS gọi firstInvalid.focus() trên select đã ẩn → đẩy về nút.
  select.addEventListener("focus", () => toggle.focus());

  wrap.close = close;
  registry.push(wrap);
  sync();
}

function init() {
  // .pi-form__select = select trong form lead; [data-pi-select] = mọi select khác muốn dùng
  // droplist tuỳ biến (bộ lọc trang Webinar…). Cờ "đã dựng" mang tên riêng để hai thứ không đụng nhau.
  document.querySelectorAll("select.pi-form__select, select[data-pi-select]").forEach(build);

  document.addEventListener("click", (e) => {
    const wrap = e.target.closest(".pi-select");
    closeAll(wrap);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });
}

document.addEventListener("DOMContentLoaded", init);
